<template>
    <a-table
      rowKey="settleId"
      :columns="columns" 
      :pagination="pagination"
      :data-source="data"
      :locale="{
        emptyText: '暂无数据'
      }"
      style="margin-top: 12px;"
    >
      <span  slot="status" slot-scope="text">{{text|statusF}}</span> 
      <span slot="withdrawAmount" slot-scope="text">{{text|toFixed2}}</span>
      <span @click="openModal(2,text.settleId)"  slot="action" slot-scope="text"><a>{{text.status|actionFormat}}</a></span> 
    </a-table>
</template>

<script>
const columns = [
  {
    title: '结算编号',
    dataIndex: 'applyNum',
    key: 'applyNum',
  },
  {
    title: '申请时间',
    dataIndex: 'createTime',
    key: 'createTime',
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '合计金额(元)',
    dataIndex: 'withdrawAmount',
    key: 'withdrawAmount',
    scopedSlots: { customRender: 'withdrawAmount' },
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];
export default {
  props:{
    data:{
      type:Array,
      default:[]
    },
    pagination:{
      type:Object,
    }
  },
  data() {
    return {
      columns,
    };
  },
   filters:{
		statusF(value){
      switch (value) {
        case 10: return "待核账";
        case 15: return "核账不通过";
        case 20: return "发票待上传";
        case 30: return "发票待核验";
        case 35: return "核验不通过";
        case 40: return "凭证待上传";
        case 50: return "已结算";
      }
		},
    actionFormat(value){
      switch (value) {
        case 10: return "核账";
        case 20: return "详情";
        case 30: return "核验";
        case 40: return "上传付款凭证";
        default: return "查看详情";
      }
    },
},
  methods:{
    openModal(index,account){
      if (index=='1') {
      } else if(index=='2') {
        this.$router.push({name:'settlement-detail',query:{id:account}})
      }
    },
  }
};
</script>